import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Injectable, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { constant } from 'src/app/constant/constant';
import { MenuItems } from 'src/app/shared/menu-items/menu-items';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    standalone: false
})

export class SidebarComponent implements OnDestroy, OnInit, OnChanges {
  shouldRun: boolean=true;
  mobileQuery: MediaQueryList;
  showDetails: boolean = true;
  showNestedItems: boolean = false;
  showNestedChildItems: boolean= false;
  panelOpenState: boolean = false;
  private _mobileQueryListener: () => void;
  selectedSubChildItem: any;

  isHovered: boolean = false;
  isExpanded = false;
  show = true;
  selectedItem: any;
  parentItem: any;
  @Input() sidenavOpened: boolean=false;
  private savedExpandedStates: Map<string, boolean> = new Map();
  private savedChildExpandedStates: Map<string, boolean> = new Map();

  constructor(
   private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private router: Router
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sidenavOpened'] && !changes['sidenavOpened'].firstChange) {
      if (this.sidenavOpened) {
        this.saveAndCollapseAllMenuItems();
      } else {
        this.restoreExpandedMenuItems();
      }
    }
  }

  saveAndCollapseAllMenuItems(): void {
    this.savedExpandedStates.clear();
    this.savedChildExpandedStates.clear();
    for (const item of this.menuItems.getMenuitem()) {
      if (item.expanded) {
        this.savedExpandedStates.set(item.state, true);
      }
      item.expanded = false;
      if (item.childMenu) {
        for (const child of item.childMenu) {
          if (child.expanded) {
            this.savedChildExpandedStates.set(item.state + '/' + child.state, true);
          }
          child.expanded = false;
        }
      }
    }
  }

  restoreExpandedMenuItems(): void {
    for (const item of this.menuItems.getMenuitem()) {
      if (this.savedExpandedStates.has(item.state)) {
        item.expanded = true;
      }
      if (item.childMenu) {
        for (const child of item.childMenu) {
          if (this.savedChildExpandedStates.has(item.state + '/' + child.state)) {
            child.expanded = true;
          }
        }
      }
    }
    this.savedExpandedStates.clear();
    this.savedChildExpandedStates.clear();
  }

  ngOnInit(): void {
    this.menuItems.setAccessLinks();
    const activeItem = sessionStorage.getItem('activeChild');
    const activeSubChild = sessionStorage.getItem('subChild');
    

    if (activeItem) {
      const parsedActiveItem = JSON.parse(activeItem);
      this.selectedItem = parsedActiveItem;
    }

     if(activeSubChild){
      const parsedActiveSubChild = JSON.parse(activeSubChild);
      this.selectedSubChildItem = parsedActiveSubChild;
     }

  }

  navigateTo(route: string): void {
  this.router.navigate([route]);
}

  clearSessionStorage() {
    sessionStorage.removeItem('parent');
    sessionStorage.removeItem('activeChild');
    sessionStorage.removeItem('isExpandedItem');
    sessionStorage.removeItem('expandedItem');
    sessionStorage.removeItem('Child'); 
    sessionStorage.removeItem('expandedStateChild');
    this.menuItems.setAccessLinks();
  }
  showNestedMenu() {
    if (this.showNestedItems != true) {

      this.showNestedItems=true;
    }else{

      this.showNestedItems=false;
    }


    // for(var mnu of mnuitem.childMenuData)
    // {
    //   mnu.expanded=false;
    // }

    // item.expanded = true;
    // this.showNestedItems=item.expanded;
  }

  onEdit(item: any) {

    var menuItems:any=[];
    menuItems=this.menuItems;
    for(var mnu of menuItems)
    {
      mnu.expanded=false;
    }

    item.expanded = true;

  }

  showNestedChildMenu(){
    if(this.showNestedChildItems!=true){

      this.showNestedChildItems=true;
    }else{

      this.showNestedChildItems=false;
    }
  }

  toggleSidenav(event: Event): void {
    event.stopPropagation();  // Prevent the parent click event from firing
    this.sidenavOpened = !this.sidenavOpened;
  }

  onOnlyItemClick(item: any){
     
     sessionStorage.removeItem('subChild');  //remove subChild to remove styling
     sessionStorage.removeItem("expandedStateChild")
     this.selectedSubChildItem = null;
     
     sessionStorage.removeItem('expandedItem');
     sessionStorage.removeItem('isExpandedItem');

     sessionStorage.removeItem('activeChild');
     sessionStorage.removeItem('parent');

     this.selectedItem = item;
     sessionStorage.setItem('activeChild', JSON.stringify(item));
       
  }

  onMenuItemClick(child: any, parent: any) {
   
    sessionStorage.setItem('expandedStateChild', JSON.stringify(child.expanded));
    this.selectedSubChildItem = null;
    sessionStorage.removeItem('subChild');  //remove subChild to remove styling
    
    this.selectedItem = child;
    this.parentItem = parent;

    if (parent && parent.childMenu) {
       sessionStorage.setItem('parent', JSON.stringify(parent));
       sessionStorage.setItem('activeChild', JSON.stringify(child))
     }
     this.menuItems.setAccessLinks();
     this.changeDetectorRef.detectChanges();
  }

  isParentSelected(item: any): boolean {
    return item === this.parentItem;
  }

  toggleExpansion(item: any ) {
    // Toggle the expanded state
    item.expanded = !item.expanded;
    // Store the updated state in sessionStorage
    sessionStorage.setItem(`isExpandedItem`, JSON.stringify(item.expanded));
    sessionStorage.setItem('expandedItem', JSON.stringify(item))
    this.menuItems.setAccessLinks();
  }

  toggleExpansionChild(child: any ) {
    // Toggle the expanded state
    child.expanded = !child.expanded;

     sessionStorage.setItem('Child', JSON.stringify(child));
     sessionStorage.setItem(`expandedStateChild`, JSON.stringify(child.expanded));
    
     this.menuItems.setAccessLinks();
    this.changeDetectorRef.detectChanges();
   
  }


  onChildClick(event: MouseEvent, child: any, parent: any): void {
    sessionStorage.setItem('Child', JSON.stringify(child));
    sessionStorage.setItem('expandedStateChild', JSON.stringify(child.expanded));
   
    if (child.subChildMenu?.length) {
          this.toggleExpansionChild(child);

          this.selectedItem = child;
          this.parentItem = parent;

      this.menuItems.setAccessLinks();
    } else {

            this.selectedItem = child; // still update selected item
            this.parentItem = parent;

            this.changeDetectorRef.detectChanges();
    }
  }

  onSubChildMenuClick(event: MouseEvent, subChild: any, child: any, parent: any): void {
    sessionStorage.removeItem('activeChild');  //removed existing activeChild 
    this.selectedSubChildItem = subChild;
    this.selectedItem = child;

    sessionStorage.setItem('subChild', JSON.stringify(subChild));
    sessionStorage.setItem('Child', JSON.stringify(child));
    sessionStorage.setItem('expandedStateChild', JSON.stringify(child.expanded));

    this.menuItems.setAccessLinks();
  }


  isSelected(child: any): boolean {
    var result = this.selectedItem && this.selectedItem.name === child.name;
    return result;
  }

isSubChildSelected(subChild: any): boolean {
  return this.selectedSubChildItem && this.selectedSubChildItem.name === subChild.name;
}
  // isParentSelected(item: any): boolean {
  //   return item.isParentSelected || (item.childMenu && item.childMenu.some(child => this.selectedItem === child));
  // }
}
